import confetti from '@hiseb/confetti';

class WinConfetti {
  init() {
    const target = document.querySelector('[data-confetti]');
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (target && !prefersReducedMotion) {
      window.addEventListener('load', () => this.launch(target));
    }
  }

  launch(target) {
    const { left, top, width, height } = target.getBoundingClientRect();
    const color = document.querySelector('.sosh')
      ? ['#ffcd0b', '#f5386e', '#ffffff']
      : ['#f15e00', '#ffffff'];

    [0.5, 0.25, 0.75].forEach((ratio, i) => {
      setTimeout(
        () =>
          confetti({
            position: { x: left + width * ratio, y: top + height / 2 },
            color,
          }),
        i * 250
      );
    });
  }
}

export default new WinConfetti();
